'use client';

import Script from 'next/script';
import { useId } from 'react';
import { trpc } from '~/trpc/client';

type SliTrackingClientProps = {
  trackingCode?: string | null;
  pageId: number;
  sliBeaconUserId: string | null;
  customCode?: string | null;
};

export function SliTrackingClient({
  trackingCode,
  pageId,
  sliBeaconUserId,
  customCode,
}: Readonly<SliTrackingClientProps>) {
  const id = useId();

  return (
    <Script id={`sli-${id}`} type="text/javascript">
      {
        /*js*/ `
        if(typeof sliSpark !== 'undefined') {
          sliSpark('sli:setPageId', '${pageId}');
          sliSpark('sli:setBeaconUserId', '${sliBeaconUserId}');
          ${trackingCode}
          ${customCode}
          sliSpark('send', 'pageview') 
        }
        `
      }
    </Script>
  );
}

type SliTrackingClientWrappedProps = {
  trackingCode?: string | null;
  customCode?: string | null;
};

export function SliTrackingClientWrapped({
  trackingCode,
  customCode,
}: Readonly<SliTrackingClientWrappedProps>) {
  const sli = trpc.sli.sliProperties.useQuery();

  if (!sli.data) {
    return null;
  }

  return (
    <SliTrackingClient
      pageId={sli.data.pageId}
      trackingCode={trackingCode}
      customCode={customCode}
      sliBeaconUserId={sli.data.sliBeaconUserId}
    />
  );
}
